import { FC } from 'react'
import classes from './emptyState.module.scss'

interface EmptyStateProps {
  onEnableClick?: () => void
  type?: 'disabled' | 'empty'
}

export const EmptyState: FC<EmptyStateProps> = ({
  onEnableClick,
  type = 'empty',
}) => {
  if (type === 'disabled') {
    return (
      <div className={classes.disabledContent}>
        <div className={classes.disabledBody}>
          <div className={classes.disabledIconWrapper}>
            <svg
              fill="none"
              height="32"
              viewBox="0 0 20 20"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clipRule="evenodd"
                d="M2.5 5C2.5 4.33696 2.76339 3.70107 3.23223 3.23223C3.70107 2.76339 4.33696 2.5 5 2.5H15C15.663 2.5 16.2989 2.76339 16.7678 3.23223C17.2366 3.70107 17.5 4.33696 17.5 5V15C17.5 15.663 17.2366 16.2989 16.7678 16.7678C16.2989 17.2366 15.663 17.5 15 17.5H5C4.33696 17.5 3.70107 17.2366 3.23223 16.7678C2.76339 16.2989 2.5 15.663 2.5 15V5ZM10.8333 6.66667C10.8333 6.44565 10.7455 6.23369 10.5893 6.07741C10.433 5.92113 10.221 5.83333 10 5.83333C9.77899 5.83333 9.56702 5.92113 9.41074 6.07741C9.25446 6.23369 9.16667 6.44565 9.16667 6.66667V13.3333C9.16667 13.5543 9.25446 13.7663 9.41074 13.9226C9.56702 14.0789 9.77899 14.1667 10 14.1667C10.221 14.1667 10.433 14.0789 10.5893 13.9226C10.7455 13.7663 10.8333 13.5543 10.8333 13.3333V6.66667ZM7.5 9.16667C7.5 8.94565 7.4122 8.73369 7.25592 8.57741C7.09964 8.42113 6.88768 8.33333 6.66667 8.33333C6.44565 8.33333 6.23369 8.42113 6.07741 8.57741C5.92113 8.73369 5.83333 8.94565 5.83333 9.16667V13.3333C5.83333 13.5543 5.92113 13.7663 6.07741 13.9226C6.23369 14.0789 6.44565 14.1667 6.66667 14.1667C6.88768 14.1667 7.09964 14.0789 7.25592 13.9226C7.4122 13.7663 7.5 13.5543 7.5 13.3333V9.16667ZM14.1667 11.6667C14.1667 11.4457 14.0789 11.2337 13.9226 11.0774C13.7663 10.9211 13.5543 10.8333 13.3333 10.8333C13.1123 10.8333 12.9004 10.9211 12.7441 11.0774C12.5878 11.2337 12.5 11.4457 12.5 11.6667V13.3333C12.5 13.5543 12.5878 13.7663 12.7441 13.9226C12.9004 14.0789 13.1123 14.1667 13.3333 14.1667C13.5543 14.1667 13.7663 14.0789 13.9226 13.9226C14.0789 13.7663 14.1667 13.5543 14.1667 13.3333V11.6667Z"
                fill="black"
                fillRule="evenodd"
              />
            </svg>
          </div>
          <h2 className={classes.disabledTitle}>Ad Analysis Is Disabled</h2>
          <p className={classes.disabledDescription}>
            Enable Ad Analysis to track your ad performance, monitor key
            metrics, and <br />
            analyze competitor campaigns across platforms.
          </p>
          <button
            className={classes.enableButton}
            onClick={onEnableClick}
            type="button"
          >
            Enable
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.emptyState}>
      <p className={classes.emptyText}>No data available.</p>
    </div>
  )
}
